const WebView = () => {
    return (
        <div style={{height:'100vh'}}>
            <iframe
                src={"https://oralidadmodernidad.org/wp-content/upgrade/geoMaps/Intergeneracional.html"}
                width="100%"
                height="100%"
                scrolling="no"
                frameBorder="0">
            </iframe>
        </div>
    );
}
export default WebView;